import { render, staticRenderFns } from "./ValidacionTab.vue?vue&type=template&id=4b3f4e7d&"
import script from "./ValidacionTab.vue?vue&type=script&lang=js&"
export * from "./ValidacionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports